// @ts-expect-error TS(2305): Module '"react/jsx-runtime"' has no exported membe... Remove this comment to see the full error message
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime"
import { useState, useEffect, useRef } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Checkbox } from "primereact/checkbox"
import { OverlayPanel } from "primereact/overlaypanel"
import { SelectButton } from "primereact/selectbutton"
import { TabMenu } from "primereact/tabmenu"
import columnsSVG from "./bx-columns.svg"
import { Button } from "../../../Button"
import { Tooltip } from "../../../Tooltip"

const OptionsTemplate = (optionSelected: any, option: any) => {
  if (optionSelected === option.value) {
    return _jsxs(
      "div",
      {
        className: "button-select",
        children: [
          _jsx(
            FontAwesomeIcon,
            { color: "#558DD2", icon: option.icon },
            void 0
          ),
          _jsx(
            "span",
            {
              className: "label-select-button",
              children: option.name,
            },
            void 0
          ),
        ],
      },
      void 0
    )
  }
  return _jsxs(
    "div",
    {
      className: "button-select",
      children: [
        _jsx(FontAwesomeIcon, { icon: option.icon }, void 0),
        _jsx(
          "span",
          {
            className: "label-select-button",
            children: option.name,
          },
          void 0
        ),
      ],
    },
    void 0
  )
}
const HeaderTurboTable = ({
  columns,
  onColumnToggle,
  toggleFilters,
  currentTable,
  setCurrentTable,
  tableOptions,
  tableTitle = "",
  showFilter = true,
  showSelectTable = true,
  showSelectColumns = true,
  showTabs = false,
  tabsOptions,
  setActiveTab,
  CustomComponent,
  dtRef
}: any) => {
  let _a
  let _b
  let _c
  let _d
  const [_selectedColumns, setSelectedColumns] = useState([])
  const [columnsOptions, setColumnsOptions] = useState([])
  const [activeIndex, setActiveIndex] = useState(0)
  const overlay = useRef(null)
  useEffect(() => {
    if (columns.length) {
      const selectableColumns = columns.filter((column: any) => column.header)
      setColumnsOptions(selectableColumns)
      setSelectedColumns(selectableColumns)
    }
  }, [columns])
  const getSelectedColumns = (lastSelected: any) => {
    let alreadyExists = false
    const newColumns = _selectedColumns.filter((column) => {
      // @ts-expect-error TS(2339): Property 'key' does not exist on type 'never'.
      if (column.key !== lastSelected.key) {
        return true
      }
      alreadyExists = true
      return false
    })
    // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
    if (!alreadyExists) newColumns.push(lastSelected)
    return newColumns
  }
  return _jsxs(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "space-between",
      },
      className: "turbo-table__header",
      children: [
        _jsxs(
          "div",
          {
            className: "turbo-table__header-left-section",
            children: [
              tableTitle
                ? _jsx(
                    "div",
                    {
                      className: "turbo-table__header-title",
                      children: tableTitle,
                    },
                    void 0
                  )
                : null,
              showTabs &&
                _jsx(
                  TabMenu,
                  {
                    model: tabsOptions,
                    activeIndex,
                    onTabChange: (e: any) => {
                      setActiveIndex(e.index)
                      setActiveTab && setActiveTab(e.index)
                    },
                  },
                  void 0
                ),
            ],
          },
          void 0
        ),
        _jsxs(
          "div",
          {
            className: "turbo-table__header-right-section",
            children: [
              (
                columnsOptions === null || columnsOptions === void 0
                  ? void 0
                  : columnsOptions.length
              )
                ? _jsxs(
                    "div",
                    {
                      style: {
                        display: showSelectColumns ? "initial" : "none",
                      },
                      children: [
                        _jsx(
                          Tooltip,
                          {
                            content: "Seleccionar columnas",
                            children: _jsx(
                              "div",
                              {
                                className: "turbo-table__column-filter-button",
                                onClick: (e: any) => {
                                  let _a
                                  if (
                                    (_a =
                                      overlay === null || overlay === void 0
                                        ? void 0
                                        : overlay.current) === null ||
                                    _a === void 0
                                      ? void 0
                                      // @ts-expect-error TS(2339): Property 'toggle' does not exist on type 'never'.
                                      : _a.toggle
                                  ) {
                                    // @ts-expect-error TS(2531): Object is possibly 'null'.
                                    overlay.current.toggle(e, null)
                                  }
                                },
                                children: _jsx(
                                  "img",
                                  {
                                    src: columnsSVG,
                                    alt: "colimns icon",
                                  },
                                  void 0
                                ),
                              },
                              void 0
                            ),
                          },
                          void 0
                        ),
                        _jsx(
                          OverlayPanel,
                          {
                            ref: overlay,
                            id: "turbo-table__overlay_panel",
                            className: "turbo-table__overlaypanel",
                            children: columns.map((column: any) => {
                              return _jsxs(
                                "div",
                                {
                                  className: "p-field-checkbox",
                                  children: [
                                    _jsx(
                                      Checkbox,
                                      {
                                        inputId: column.key,
                                        name: "category",
                                        value: column,
                                        onChange: () => {
                                          const selected =
                                            getSelectedColumns(column)
                                          setSelectedColumns(selected)
                                          onColumnToggle(selected)
                                        },
                                        checked:
                                          _selectedColumns === null ||
                                          _selectedColumns === void 0
                                            ? void 0
                                            : _selectedColumns.some(
                                                (item) =>
                                                  // @ts-expect-error TS(2339): Property 'key' does not exist on type 'never'.
                                                  item.key === column.key
                                              ),
                                      },
                                      void 0
                                    ),
                                    _jsx(
                                      "label",
                                      {
                                        htmlFor: column.key,
                                        children: column.header,
                                      },
                                      void 0
                                    ),
                                  ],
                                },
                                column.key
                              )
                            }),
                          },
                          void 0
                        ),
                      ],
                    },
                    void 0
                  )
                : null,
              _jsx(
                "div",
                {
                  style: { display: showFilter ? "flex" : "none" },
                  className: "turbo-table__filter",
                  children:
                    ((_b =
                      (_a =
                        dtRef === null || dtRef === void 0
                          ? void 0
                          : dtRef.current) === null || _a === void 0
                        ? void 0
                        : _a.props) === null || _b === void 0
                      ? void 0
                      : _b.filters) &&
                    Object.keys(
                      (_d =
                        (_c =
                          dtRef === null || dtRef === void 0
                            ? void 0
                            : dtRef.current) === null || _c === void 0
                          ? void 0
                          : _c.props) === null || _d === void 0
                        ? void 0
                        : _d.filters
                    ).length
                      ? _jsxs(
                          "div",
                          {
                            className: "turbo-table__filter-button-container",
                            children: [
                              _jsx(
                                Button,
                                {
                                  onClick: () => {
                                    toggleFilters(true)
                                  },
                                  icon: "filter",
                                  iconLibrary: "fas",
                                  iconPosition: "right",
                                  tooltipText: "Limpiar filtros",
                                  backgroundColor: "transparent",
                                  className: "turbo-table__filter-button-clear",
                                },
                                void 0
                              ),
                              _jsx(
                                "div",
                                {
                                  className: "turbo-table__filter-button-slash",
                                },
                                void 0
                              ),
                            ],
                          },
                          void 0
                        )
                      : _jsx(
                          Button,
                          {
                            onClick: () => toggleFilters(),
                            icon: "filter",
                            iconLibrary: "fas",
                            iconPosition: "right",
                            tooltipText: "Mostrar/Ocultar filtros",
                            backgroundColor: "transparent",
                            className: "turbo-table__filter-button",
                          },
                          void 0
                        ),
                },
                void 0
              ),
              CustomComponent,
              _jsx(
                "div",
                {
                  className: "select-button-wrapper",
                  style: {
                    display: showSelectTable ? "initial" : "none",
                  },
                  children: _jsx(
                    SelectButton,
                    {
                      value: currentTable,
                      options: tableOptions,
                      onChange: (e: any) => {
                        if (setCurrentTable) {
                          setCurrentTable(e.value ? e.value : 0)
                        }
                      },
                      itemTemplate: (option: any) => OptionsTemplate(currentTable, option),
                    },
                    void 0
                  ),
                },
                void 0
              ),
            ],
          },
          void 0
        ),
      ],
    },
    void 0
  );
}
export default HeaderTurboTable
